<template>
    <side-container
        v-if="visible"
        :width="500"
        :headerTitle="headerTitle"
        :isShowFooterBtn="false"
        :isLoading="isLoading"
        @close="$emit('update:visible', false)">
        <div class="body">
            <div class="role-name fx-v-center"
                :class="{ 'role-name-error': isRoleNameError }">
                <span class="required">角色名称：</span>
                <el-input v-model="roleName"
                    placeholder="请输入角色名称"
                    maxlength="15"
                    :show-word-limit="true"
                    @input="roleNameipt"/>
                <span v-if="isRoleNameError"
                    class="role-name-color-error ml-12">已存在该角色名称</span>
            </div>
            <div class="role-permission-wrap fx mt-12">
                <p class="role-permission-des mt-5">角色权限：</p>
                <div class="role-permissions">
                    <!-- 后台 -->
                    <div class="top-all">
                        <el-switch
                            v-model="allPermissions.backstage.isCanUse"
                            active-color="#009688"
                            inactive-color="#ddd"
                            :disabled="false"/>
                        <span>进入零售后台</span>
                        <el-checkbox
                            v-model="allPermissions.backstage.isCheckAll"
                            class="all"
                            :disabled="!allPermissions.backstage.isCanUse"
                            :indeterminate="allPermissions.backstage.isIndeterminate"
                        >全选</el-checkbox>
                    </div>
                    <div class="top-item-wrapper">
                        <el-checkbox
                            v-for="item in permissions.backstage"
                            v-model="item.value"
                            :key="item.name"
                            :disabled="!allPermissions.backstage.isCanUse"
                        >{{ item.name }}</el-checkbox>
                    </div>
                    <!-- 收银台 -->
                    <div class="top-all mt-20">
                        <el-switch
                            v-model="allPermissions.cashier.isCanUse"
                            active-color="#009688"
                            inactive-color="#ddd"
                            :disabled="false"/>
                        <span>进入收银台</span>
                        <el-checkbox
                            v-model="allPermissions.cashier.isCheckAll"
                            class="all"
                            :disabled="!allPermissions.cashier.isCanUse"
                            :indeterminate="allPermissions.cashier.isIndeterminate"
                        >全选</el-checkbox>
                    </div>
                    <div class="top-item-wrapper">
                        <el-checkbox
                            v-for="item in permissions.cashier"
                            v-model="item.value"
                            :key="item.name"
                            :disabled="!allPermissions.cashier.isCanUse"
                        >{{ item.name }}</el-checkbox>
                    </div>

                    <!-- app -->
                    <div class="top-all mt-20">
                        <el-switch
                            v-model="allPermissions.appRole.isCanUse"
                            active-color="#009688"
                            inactive-color="#ddd"
                            :disabled="false"/>
                        <span>进入零售通app</span>
                        <el-checkbox
                            v-model="allPermissions.appRole.isCheckAll"
                            class="all"
                            :disabled="!allPermissions.appRole.isCanUse"
                            :indeterminate="allPermissions.appRole.isIndeterminate"
                        >全选</el-checkbox>
                    </div>
                    <div class="top-item-wrapper">
                        <el-checkbox
                            v-for="item in permissions.appRole"
                            v-model="item.value"
                            :key="item.name"
                            :disabled="!allPermissions.appRole.isCanUse"
                        >{{ item.name }}</el-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <!--  footer  -->
        <div
            class="footer"
            slot="footer">
            <div
                class ="btn-wrapper"
                :class="mode">
                <el-button
                    plain
                    size="medium"
                    type="danger" 
                    v-if="mode === 'update'"
                    :loading="isDeleteLoading"
                    @click="deleteClick"
                >删除</el-button>
                <el-button
                    size="medium"
                    type="primary"
                    :loading="isConfirmLoading"
                    :disabled="!canConfirm"
                    @click="confirmClick"
                >确认</el-button>
            </div>
        </div>
    </side-container>
</template>

<script lang='tsx'>
import { createComponent, ref, reactive, computed, watch, SetupContext } from '@vue/composition-api'
import SideContainer from "@/components/layout/side-container-style2.vue"
import { openMessage, openWarning } from '@/utils/system'
import { PermissionSetInterface } from '../permission_set.vue'
import $fetch from '../../../../api'
import { inputSpaceLimit } from '@/utils/index'

enum PermissionType {
    backstage = 'backstage',
    cashier = 'cashier',
    appRole = 'appRole'
}

enum modeType {
    create = 'create',
    update = 'update'
}

interface PermissionsItemInterface {
    id: number,
    value: boolean,
    name: string
}

export default createComponent({
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        roleNameMap: {
            type: Array,
            required: true
        },
        staffCount: {
            type: Number
        },
        roleInfo: {
            type: Object
        },
        confirmCallback: {
            type: Function
        },
        deleteCallback: {
            type: Function
        }
    },

    setup: (
        props: {
            visible: boolean,
            mode: modeType,
            staffCount: number,
            roleNameMap: string[],
            roleInfo: PermissionSetInterface,
            confirmCallback?: () => void,
            deleteCallback?: () => void
        },
        ctx: SetupContext
    ) => {
        const isLoading = ref(false)
        const isConfirmLoading = ref(false)
        const isDeleteLoading = ref(false)
        const isRoleNameError = ref(false)
        const roleName = ref('')
        const permissions = reactive({
            backstage: [
                {
                    id: 3,
                    value: false,
                    name: '店铺数据'
                },
                {
                    id: 4,
                    value: false,
                    name: '会员管理'
                },
                {
                    id: 5,
                    value: false,
                    name: '店铺设置'
                },
                {
                    id: 6,
                    value: false,
                    name: '添加员工'
                },
                {
                    id: 7,
                    value: false,
                    name: '删除员工'
                },
                {
                    id: 8,
                    value: false,
                    name: '编辑/配置角色'
                },
                {
                    id: 9,
                    value: false,
                    name: '订单退款'
                },
                {
                    id: 10,
                    value: false,
                    name: '添加/删除商品'
                },
                {
                    id: 11,
                    value: false,
                    name: '商品上/下架'
                }
            ],
            cashier: [
                {
                    id: 12,
                    value: false,
                    name: '收银台改价'
                },
                {
                    id: 13,
                    value: false,
                    name: '订单减免'
                },
                {
                    id: 14,
                    value: false,
                    name: '订单退款'
                },
                {
                    id: 15,
                    value: false,
                    name: '订单折扣'
                },
                {
                    id: 16,
                    value: false,
                    name: '订单抹零'
                },
                {
                    id: 29,
                    value: false,
                    name: '查看收银数据'
                }
            ],
            appRole: [
                {
                    id: 18,
                    value: false,
                    name: '店铺数据'
                },
                {
                    id: 19,
                    value: false,
                    name: '会员管理'
                },
                {
                    id: 20,
                    value: false,
                    name: '店铺设置'
                },
                {
                    id: 21,
                    value: false,
                    name: '添加员工'
                },
                {
                    id: 22,
                    value: false,
                    name: '删除员工'
                },
                {
                    id: 23,
                    value: false,
                    name: '编辑/配置角色'
                },
                {
                    id: 24,
                    value: false,
                    name: '订单退款'
                },
                {
                    id: 25,
                    value: false,
                    name: '添加/删除商品'
                },
                {
                    id: 26,
                    value: false,
                    name: '商品上/下架'
                },
                {
                    id: 28,
                    value: false,
                    name: '删除手工会员'
                }
            ]
        })
        const allPermissions = reactive({
            backstage: {
                isCanUse: true,
                isCheckAll: false,
                isIndeterminate: false
            },
            cashier: {
                isCanUse: true,
                isCheckAll: false,
                isIndeterminate: false
            },
            appRole: {
                isCanUse: true,
                isCheckAll: false,
                isIndeterminate: false
            }
        })
        const permissionArr = ref<number[]>([])

        // not reactive
        const typeArr: PermissionType[] = [PermissionType.backstage, PermissionType.cashier, PermissionType.appRole]
        const typeObj = {
            backstage: 1,
            cashier: 2,
            appRole: 17
        }
        const topPermissionArr = [0, 1, 2, 17]
        const store = ctx.root.$store

        typeArr.forEach((type: PermissionType) => {
            watch(() => allPermissions[type].isCanUse, (newVal) => {
                if (!newVal) {
                    allPermissions[type].isIndeterminate = false
                    allPermissions[type].isCheckAll = false
                    permissions[type].forEach((item: any) => {
                        if (item.value) {
                            item.value = false
                        }
                    })
                    permissionArr.value = permissionArr.value.filter((item: any) => item !== typeObj[type])
                } else {
                    if (!permissionArr.value.includes(typeObj[type]) && typeObj[type] != null) {
                        permissionArr.value.push(typeObj[type])
                    }
                }
            })

            watch(() => allPermissions[type].isCheckAll, (newVal) => {
                const isIndeterminate = allPermissions[type].isIndeterminate
                if (isIndeterminate) {
                    allPermissions[type].isIndeterminate = false
                    allPermissions[type].isCheckAll = true
                    if (newVal) {
                        permissions[type].forEach((item: any) => {
                            if (item.value !== newVal) {
                                item.value = newVal
                            }
                        })
                    }
                } else {
                    permissions[type].forEach((item: any) => {
                        if (item.value !== newVal) {
                            item.value = newVal
                        }
                    })
                }
            })

            watch(permissions[type].map((item: any) => () => item.value), () => {
                subCheckboxChange(type)
            })
        })

        watch(() => props.visible, (newVal) => {
            if (newVal) {
                // 弹窗被打开
                isRoleNameError.value = false
                switch (props.mode) {
                    case modeType.create:
                        roleName.value = ''
                        setPermissions(props.roleInfo.permission_list)
                        break
                    case modeType.update:
                        roleName.value = props.roleInfo.name
                        permissionArr.value = props.roleInfo.permission_list.filter((item: number) => topPermissionArr.includes(item))
                        setPermissions(props.roleInfo.permission_list)
                        break
                    default:
                        break
                }
            }
        })

        const headerTitle = computed(() => {
            switch (props.mode) {
                case modeType.create:
                    return '添加角色'
                case modeType.update:
                    return '编辑角色'
                default:
                    return '未知标题'
            }
        })

        const canConfirm = computed(() => {
            return roleName.value !== '' && !isRoleNameError.value
        })

        const backstagePermissionList = computed(() => {
            return permissions.backstage.filter((item: any) => item.value).map((item: any) => item.id)
        })

        const cashierPermissionList = computed(() => {
            return permissions.cashier.filter((item: any) => item.value).map((item: any) => item.id)
        })

        const appRolePermissionList = computed(() => {
             return permissions.appRole.filter((item: any) => item.value).map((item: any) => item.id)
        })

        const roleNameComputedMap = computed(() => {
            return ['暂不选择'].concat(props.roleNameMap)
        })

        function roleNameipt() {
            inputSpaceLimit(roleName, 'value')
            if (roleNameComputedMap.value.includes(roleName.value)) {
                isRoleNameError.value = true
            } else {
                isRoleNameError.value = false
            }
        }

        function setPermissions(permissionList: number[]) {
            typeArr.forEach((type: PermissionType) => {
                permissions[type].forEach((item: any) => {
                    if (permissionList.includes(item.id)) {
                        item.value = true
                    } else {
                        item.value = false
                    }
                })
                allPermissions[type].isCanUse = permissionList.includes(typeObj[type])
            })
        }

        function subCheckboxChange(type: string) {
            if (permissions[type] == null) {
                return openMessage('error', '预期之外的错误')
            }
            const sum = permissions[type].reduce((next: any, prev: any) => {
                next += prev.value
                return next
            }, 0)
            if (sum === 0) {
                allPermissions[type].isIndeterminate = false
                allPermissions[type].isCheckAll = false
            } else if (sum === permissions[type].length) {
                allPermissions[type].isIndeterminate = false
                allPermissions[type].isCheckAll = true
            } else {
                allPermissions[type].isIndeterminate = true
            }
        }

        async function deleteClick() {
            try {
                if (!store.getters['shop/canIUse'](8)) {
                    return openMessage('error', '暂无配置员工角色权限，请联系超管开启')
                }
                const isConfirm = await openWarning({
                    title: '删除角色',
                    type: "danger",
                    render: (h) => (
                        <div style="text-align: center">
                            <div class="fx-v-center fx-h-center" style="height: 20px; line-height: 20px; font-size: 14px; font-weight: 600; color: #333">确定删除角色&nbsp;<span class="color-red">{ props.roleInfo.name }</span>&nbsp;吗？</div>
                            {props.staffCount ? <div style="width: 264px; line-height: 16px; margin: 8px auto 0; font-size: 12px; color: #666">员工列表中有{ props.staffCount }人使用该角色，删除后，该员工将失去该角色及其权限，需为员工配置新的角色权限</div> : ''}
                        </div>
                    )
                }).then(() => true).catch(() => false)
                if (isConfirm) {
                    isDeleteLoading.value = true
                    await $fetch.post({
                        url: '/shop/deletepermissionset',
                        params: {
                            permission_set_id: props.roleInfo.id
                        }
                    })
                    ctx.emit('update:visible', false)
                    openMessage('success', '删除成功')
                    props.deleteCallback && props.deleteCallback()
                }
            } catch (e) {
                openMessage("error", e.message || '删除失败')
            } finally {
                isDeleteLoading.value = false
            }
        }

        async function confirmClick() {
            try {
                if (!store.getters['shop/canIUse'](8)) {
                    return openMessage('error', '暂无配置员工角色权限，请联系超管开启')
                }
                isConfirmLoading.value = true
                if (props.mode === modeType.create) {
                    await addRolePermission()
                    ctx.emit('update:visible', false)
                    openMessage('success', '添加角色成功')
                }
                if (props.mode === modeType.update) {
                    await editRolePermission()
                    ctx.emit('update:visible', false)
                    openMessage('success', '编辑角色成功')
                }
                props.confirmCallback && props.confirmCallback()
            } catch (e) {
                if (props.mode === modeType.create) {
                    openMessage("error", e.message || '添加员工失败')
                }
                if (props.mode === modeType.update) {
                    openMessage("error", e.message || '编辑员工失败')
                }
            } finally {
                isConfirmLoading.value = false
            }
        }

        async function editRolePermission() {
            const result = await $fetch.post({
                url: '/shop/editstaffpermissionset',
                params: {
                    permission_set_id: props.roleInfo.id,
                    permission_set_name: roleName.value,
                    permission_list: permissionArr.value.concat(backstagePermissionList.value).concat(cashierPermissionList.value).concat(appRolePermissionList.value)
                }
            })
            return result
        }

        async function addRolePermission() {
            const result = await $fetch.post({
                url: '/shop/addstaffpermissionset',
                params: {
                    permission_set_name: roleName.value,
                    permission_list: permissionArr.value.concat(backstagePermissionList.value).concat(cashierPermissionList.value).concat(appRolePermissionList.value)
                }
            })
            return result
        }

        return {
            // data
            isLoading,
            isDeleteLoading,
            isConfirmLoading,
            isRoleNameError,
            headerTitle,
            roleName,
            permissions,
            allPermissions,
            // computed
            canConfirm,
            // methods
            roleNameipt,
            deleteClick,
            confirmClick
        }
    },
    components: {
        SideContainer
    }
})
</script>

<style lang="scss" scoped>
.body {
    padding: 20px;
    font-size: 14px;
    color: #333;

    ::v-deep div[class^='el-input'] .el-input__inner {
        padding: 0 8px;
    }

    ::v-deep .el-checkbox .el-checkbox__input + .el-checkbox__label {
        font-weight: 400;
    }

    .role-name {
        &-error {
            ::v-deep .el-input__inner {
                outline: none;
                border-color: #FF1D1D;
            }
        }

        .role-name-color-error {
            color: #FF1D1D;
        }

        ::v-deep .el-input {
            width: 263px;
        }
    }

    .role-permission-des {
        flex: none;
    }

    .role-permissions {
        .top-all {
            display: flex;
            align-items: center;

            > span {
                margin: 0 30px 0 8px;
            }
        }

        .top-item-wrapper {
            ::v-deep .el-checkbox {
                margin: 10px 0 0;
                width: 180px;
            }
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 7px 12px;

    .btn-wrapper.update {
        ::v-deep .el-button--danger {
            border: 1px solid #ddd !important;
            border-radius: 4px 0 0 4px !important;
        }

        ::v-deep .el-button--primary {
            margin-left: 0;
            border-radius: 0 4px 4px 0 !important;
        }
    }
}
</style>
